export const MISSING_DATA_INPUT_MESSAGE = 'No sample to display';

export const MULTI_SELECT_CHIP_HTML_TAG = 'multi-select-chip';

export const DATA_CHIP_HTML_TAG = 'data-chip';
export const INSERT_DATA_DELIMITER_PREFIX = '{{';
export const INSERT_DATA_DELIMITER_SUFFIX = '}}';

export const TEXT_PARSER_HTML_TAG = 'text-parser-chip';
export const TEXT_PARSER_DELIMITER_PREFIX = '[[';
export const TEXT_PARSER_DELIMITER_SUFFIX = ']]';
